import { resolveDirectAppUrl } from '@/config.js';

function appBase() {
  return resolveDirectAppUrl();
}

/** The Direct app's 14 day trial signup; ref=website tells the API where it came from. */
export function getTrialSignupHref() {
  return appBase() + '/#/signup?ref=website';
}

/**
 * Experience IMPROVE marketing journey: interactive tour → trial → Live.
 * Use getTrialSignupHref() when you need the raw signup URL.
 */
export function getExperienceHref() {
  return '/experience';
}

export function getImproveLiveHref() {
  return '/improve-live';
}

export function getLoginHref() {
  return appBase() + '/#/login';
}

/** Canonical conversion CTAs for the marketing site. */
export const CTA = {
  watchDemo: {
    label: 'Watch the 4-minute demo',
    shortLabel: 'Watch the 4-minute demo',
    href: '/watch-demo',
    description: 'See IMPROVE in action and discover how it can help your business.',
  },
  experience: {
    label: 'Experience IMPROVE',
    shortLabel: 'Experience IMPROVE',
    href: '/experience',
    external: false,
    description:
      'Start a 14-day trial to take the interactive tour in your account, or book a free IMPROVE Live webinar.',
  },
  getStarted: {
    label: 'Buy IMPROVE',
    shortLabel: 'Buy IMPROVE',
    href: '/get-started',
    description: 'Choose your package and begin transforming learning in your organisation today.',
  },
};

export const STANDARD_CTA = {
  eyebrow: 'Ready to take the next step?',
  lead:
    'See why growing businesses are choosing IMPROVE to onboard, train and develop their people.',
};
